/**
 * @description Примись показа представления шагов ОнБординга
 */
import { FETCH_STEPS } from '@/store/actions/onBoarding';

export default {
  data() {
    return {
      /**
       * @description Шаг ОнБординга.
       * @type {object}
       */
      step: {},
    };
  },
  async created() {
    await this.fetchSteps();
    this.setStepByStepSlug(this.stepSlug);
  },
  methods: {
    /**
     * Определить позиции элементов "Родителей"
     * и вставить позицию для компонентов их "Дочек" в ОнБординге.
     *
     * @param access {boolean} есть ли потребность в компоненте.
     * @param parentId {string} Айди компонента "Родителя".
     * @param childId {string} Айди компонента "Дочки".
     * @param defaultPosition {object} Дефолтная позиция объекта.
     * @param relationSide {string} Относительно какой стороны выравниваем
     *
     * @return void
     */
    definePositionAndSetPositionsToChildComponent(
      access,
      parentId,
      childId,
      relationSide = '',
      defaultPosition = null,
    ) {
      const parent = document.querySelector(parentId);
      const child = document.querySelector(childId);
      if (access && parent && child) {
        const preparedPosition = this.preparePosition(parent);
        this.setPositionToComponent(preparedPosition, child, relationSide);
        return;
      }
      if (defaultPosition && child) {
        this.setPositionToComponent(defaultPosition, child, relationSide);
      }
    },
    /**
     * Подготавливаем параметры позиции
     *
     * @param component Компонент "акцептор" позиции.
     * @return {{top: number, left: number, bottom: number, right: number}}
     */
    preparePosition(component) {
      const rawPosition = component.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      return {
        left: rawPosition.left,
        top: rawPosition.top,
        bottom: windowHeight - rawPosition.bottom,
        right: windowWidth - rawPosition.right,
      };
    },
    /**
     * Вставить позицию в компонент.
     *
     * @param position
     * @param component
     * @param relationSide {string} Относительно какой стороны выравниваем
     * Принимает в себя строку в корой могут быть 4 специальных символа
     * 'l' - left,
     * 'r' - right,
     * 'b' - bottom,
     * 't' - top,
     *
     * @return void
     */
    setPositionToComponent(position, component, relationSide = '') {
      component.style.setProperty('position', 'absolute');
      if (relationSide.includes('l')) {
        component.style.setProperty('left', `${position.left}px`);
      }
      if (relationSide.includes('r')) {
        component.style.setProperty('right', `${position.right}px`);
      }
      if (relationSide.includes('b')) {
        component.style.setProperty('bottom', `${position.bottom}px`);
      }
      if (relationSide.includes('t')) {
        component.style.setProperty('top', `${position.top}px`);
      }
      if (relationSide === '') {
        component.style.setProperty('left', `${position.left}px`);
        component.style.setProperty('top', `${position.top}px`);
        component.style.setProperty('right', `${position.right}px`);
        component.style.setProperty('bottom', `${position.bottom}px`);
      }
    },
    /**
     * Запросить онбординг шаги
     *
     * @return {Promise<void>}
     */
    async fetchSteps() {
      await this.$store.dispatch(FETCH_STEPS);
    },
    /**
     * Обрабатываем события показа представления Онбординга
     *
     * @return void
     */
    async showedOnboarding(slugStep) {
      await this.setStepByStepSlug(slugStep);
    },
    /**
     * Запросить шаг ОнБординга из хранилища
     *
     * @return {Promise<void>}
     */
    async setStepByStepSlug(slugStep) {
      this.step = this.$store.getters.getStepBySlug(slugStep);
    },
    /**
     * Обновить показы юзера,
     * Действие: "Пользователь посмотрел представление"
     *
     * @param slugShow
     * @param stepSlug
     *
     * @return {Promise<void>}
     */
    async uploadShowsUser(slugShow, stepSlug = this.stepSlug) {
      await this.$onBoardingGateway.setShowToUser([slugShow]);
      await this.$store.dispatch(FETCH_STEPS);
      this.setStepByStepSlug(stepSlug);
    },
  },
};
